import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../context/ThemeContext';
import { useRef, useEffect, useState } from 'react';
import { keyframes } from '@emotion/react';

export default function Footer() {
    const { theme } = useThemeContext();
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const [scrollDistance, setScrollDistance] = useState(0);

    useEffect(() => {
        const updateDistance = () => {
            const containerWidth = containerRef.current?.offsetWidth || 0;
            const textWidth = textRef.current?.offsetWidth || 0;
            if (containerWidth && textWidth) {
                setScrollDistance(containerWidth + textWidth);
            }
        };

        updateDistance();
        window.addEventListener('resize', updateDistance);
        return () => window.removeEventListener('resize', updateDistance);
    }, []);

    const scrollAnimation = keyframes`
        0% { transform: translateX(${containerRef.current?.offsetWidth || 0}px); }
        100% { transform: translateX(-${scrollDistance}px); }
    `;

    return (
        <Box
            component="footer"
            sx={{
                mt: 10,
                py: 4,
                px: 2,
                backgroundColor: theme.background,
                color: '#ffffff',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
            }}
        >

            {/* 🔷 Logo */}
            <img
                src="/HOT_logo.png"
                alt="House of Technology Logo"
                style={{
                    height: 90,
                    marginBottom: 12,
                    borderRadius: '8px',
                    objectFit: 'contain',
                }}
            />

            <Typography variant="body2" sx={{ fontSize: '14px', color: theme.text }}>
                © {new Date().getFullYear()} House of Technology. All rights reserved.
            </Typography>
        </Box>
    );
}
